import TradingOffersList from 'modules/trading/pages/TradingOffersList';
import { TradingOfferType } from 'types/TradingOffer';
import { TradingOffersListProvider } from '../pages/TradingOffersList/context/TradingOffersListContext';

const TradingSellOffersListContainer = () => (
  <TradingOffersListProvider>
    <TradingOffersList tradingOfferType={TradingOfferType.SELL} />
  </TradingOffersListProvider>
);

export default TradingSellOffersListContainer;
